import type { TStore } from "~/app/pages/Store/types/TStore";
import { requestApi } from "~/app/services/api/requestApi";

export async function getWelcomeGift() {
  const result: TStore = await requestApi({
    endpoint: "store",
    method: "get",
  });

  const data = result.Data.Store.StoreFronts.WebSpecialOffers.StoreFront.Listings.find(
    (k) => k.Name === "WebWelcomeGift",
  );
  const purchaseCount = Object.entries<number>(
    result.Data.PurchaseCounts.UserStoreListingPurchaseCounts,
  ).find((k) => k[0] === "WebWelcomeGift");
  const isWelcomeGiftClaimed = Array.isArray(purchaseCount) && purchaseCount[1] > 0;

  return {
    isWelcomeGiftClaimed,
    storeListing: data ? data?.StoreListing : null,
  };
}
